// TCX-1122: `top` for an in-page sticky element, so it pins just below the
// pinned header instead of behind it, at any breakpoint. The height comes from
// --header-height (MobileHeader/index.scss).
export const stickyTop = (offset = 0): string =>
  `calc(var(--header-height) + ${offset}px)`;
